import { Button } from "@/interfaces/Button"
import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"
import { ButtonStatusEnum } from "@/enums/buttons/ButtonStatusEnum"
import { useBot } from "./useBot"
import { ButtonPlacementEnum } from "@/enums/buttons/ButtonPlacementEnum"

const axios = useAxios()

export interface CreateButtonDTO {
  name: string
  url: string
  status: ButtonStatusEnum
  organizationId: number
  placement?: ButtonPlacementEnum
}

export interface UpdateButtonDTO {
  name?: string
  url?: string
  status?: ButtonStatusEnum
  placement?: ButtonPlacementEnum
}

export interface GetAllButtonsParams {
  page?: string
  perPage?: string
}

export function useButton() {
  const { selectedBot } = useBot()

  const create = async (payload: CreateButtonDTO): Promise<Button> => {
    const response = await axios.post(`/bots/${selectedBot.value?.id}/buttons`, payload)

    return response.data
  }

  const update = async (id: number, payload: UpdateButtonDTO): Promise<void> => {
    await axios.patch(`/bots/${selectedBot.value?.id}/buttons/${id}`, payload)
  }

  const getAll = async (params?: GetAllButtonsParams): Promise<Pagination<Button>> => {
    if (params) {
      params = Object.fromEntries(
        Object.entries(params).filter(([param, value]) => !!value)
      )
    }

    const response = await axios.get(`/bots/${selectedBot.value?.id}/buttons`, { params })

    return response.data
  }

  const destroy = async (id: number): Promise<void> => {
    await axios.delete(`/bots/${selectedBot.value?.id}/buttons/${id}`)
  }

  return {
    create,
    getAll,
    update,
    destroy
  }
}